module.exports = __webpack_public_path__ + "media/diverticula.4620d087.wav";